import script from "./PhoneNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneNumber.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneNumber.vue?vue&type=style&index=0&id=419df63c&lang=css"

const __exports__ = script;

export default __exports__